

$(function(){
  $('#top-page .btn-08').on('click',function(){
    $('.table-wrap').stop(true).slideToggle(500);
  });

  let mySwiper = null;

function initSwiperIfNeeded() {
  const isMobile = window.innerWidth <= 989;

  if (isMobile && !mySwiper) {
    // 初期化（スマホ以下の時）
    mySwiper = new Swiper('.swiper2', {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      // 他オプション...
    });
  } else if (!isMobile && mySwiper) {
    // スワイパー破棄（PC表示の時）
    mySwiper.destroy(true, true);
    mySwiper = null;
  }
}

// 初回読み込み時とリサイズ時に実行
window.addEventListener('load', initSwiperIfNeeded);
window.addEventListener('resize', initSwiperIfNeeded);

const options = {
  arrows: false,
  pagination: false,
  type: "loop",
  drag: false,
  autoWidth: true,
  gap: 20,
  autoScroll: {
    speed: 1,
    pauseOnHover: false,
  }
};

const target1 = document.querySelector("#splide1");
if (target1) {
  const splide1 = new Splide(target1, options);
  splide1.mount(window.splide.Extensions);
}
  
const target2 = document.querySelector("#splide2");
if (target2) {
const splide2 = new Splide(target2, options);
splide2.mount(window.splide.Extensions);
}
  
const target3 = document.querySelector("#splide3");
if (target3) {
const splide3 = new Splide(target3, options);
splide3.mount(window.splide.Extensions);
}



  
const swiper3 = new Swiper(".swiper3", {
  slidesPerView: 1.5,
  centeredSlides: true,
  loop: true,
  speed: 1000,
  spaceBetween: 30,
      autoplay: {
            delay: 2000,
        },
  breakpoints: {
    // 768px以上の場合
    768: {
      slidesPerView: 3,
      centeredSlides: true,
    }
  },

});
const swiper4 = new Swiper(".swiper-04", {
  allowTouchMove: false,
  loop: true,
  slidesPerView: 6,
  speed: 3000,
  centeredSlides: true,
  spaceBetween: 10, // スライド間のスペース（必要に応じて調整）
  autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },
  breakpoints: {
    // 768px以上の場合
     768: {
      spaceBetween: 20, // スライド間のスペース（必要に応じて調整）
       slidesPerView: 6, // 一度に表示するスライドの数を1に設定
    }
  },
});

const swiper5 = new Swiper(".swiper-05", {
  allowTouchMove: false,
  loop: true,
  slidesPerView: 6,
  speed: 3000,
  spaceBetween: 10, // スライド間のスペース（必要に応じて調整）
  autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },
  breakpoints: {
    // 768px以上の場合
     768: {
      slidesPerView: 6, // 一度に表示するスライドの数を1に設定
      spaceBetween: 20,
    }
  },
});


  const swiper = new Swiper(".swiper", {
     allowTouchMove: true,
    loop: true,
    speed: 1000,
    autoplay: {
    delay: 5000,
  },
  // ページネーションが必要なら追加
  pagination: {
    el: ".swiper-pagination"
  },
  // ナビボタンが必要なら追加
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  }
});



  let $subNav = $('.sub-nav');
  let changeH = 1;
  let isHovered = false;
  let FVheight = $('#top-page .fv').height();
  let isNavDown = false;
  if ($(window).width() > 989) {





    
    $(window).scroll(function () {
     var shouldNavBeDown = $(window).scrollTop() > FVheight;

    if (shouldNavBeDown && !isNavDown) {
        $subNav.addClass('nav-down');
        isNavDown = true;
    } else if (!shouldNavBeDown && isNavDown) {
        $subNav.removeClass('nav-down');
        isNavDown = false;
    }

      
    });

    $('#HeaderMenu-ecoco, .sub-nav').hover(
      function(){
        isHovered = true;
        $subNav.addClass('nav-down');
      },
      function(){
        isHovered = false;
        $subNav.removeClass('nav-down');
      }
    );



  }else{
    $('.sub-nav-sp ul a').on('click',function(){
      $('.menu-drawer-container').removeAttr('open').removeClass('menu-opening');
      $('.menu-drawer-container summary').attr('aria-expanded',false);
    });

//     const swiper = new Swiper(".swiper2", {
//     allowTouchMove: true,
//   // ページネーションが必要なら追加
//   // pagination: {
//   //   el: ".swiper-pagination"
//   // },
//   // ナビボタンが必要なら追加
//   navigation: {
//     nextEl: ".swiper-button-next",
//     prevEl: ".swiper-button-prev"
//   }
// });

}






  //===========================================================
  // プライバシーポリシーのチェック時の購入ボタンの活性、非活性制御（カートページ）
  //===========================================================
  $(document).on('click','.check',function() {
    if ($("#main-cart-footer .check").prop("checked") == true) {
      $('#main-cart-footer .cart__checkout-button, #main-cart-footer .cart__footer .cart__dynamic-checkout-buttons').removeClass('c_none');
    } else {
      $('#main-cart-footer .cart__checkout-button, #main-cart-footer .cart__footer .cart__dynamic-checkout-buttons').addClass('c_none');
    }
  });

  //===========================================================
  //SN(シリアルナンバー)必須
  //===========================================================
  $(".input_sn").on("input", function() {
    var inputLength = $(this).val().length; //input に入力された文字を取得
    console.log(inputLength);
    // T9 devices can only purchase Japan plans.
    var checkTypeOfDevice = String($(this).data("check-type-of-device")) === "true";
    if(inputLength === 13){ //もし文字が入っていれば
      if(checkTypeOfDevice) {
        if($(this).val().substring(0, 2) === "29") {
          $(".okawari .product-form__submit").prop('disabled', true); //disabled を有効にする＝ボタンが押せない
          $(".okawari .product-form__submit span").text('端末：T9では購入できません');
        } else {
          $(".okawari .product-form__submit").prop('disabled', false); //disabled を無効にする＝ボタンが押せる
           $(".okawari .product-form__submit span").text('カートへ追加');
        }
      } else {
        $(".okawari .product-form__submit").prop('disabled', false); //disabled を無効にする＝ボタンが押せる
        $(".okawari .product-form__submit span").text('カートへ追加');
      }
    }else{
      $(".okawari .product-form__submit").prop('disabled', true); //disabled を有効にする＝ボタンが押せない
      $(".okawari .product-form__submit span").text('13桁のSNを入力してください');
    }
  });

  //===========================================================
  //法人用　IMEI番号必須
  //===========================================================
  $(".input_imei").on("input", function() {
    var inputLength = $(this).val().length; //input に入力された文字を取得
    console.log(inputLength);
    if(inputLength === 15){ //もし文字が入っていれば
      $(".okawari .product-form__submit").prop('disabled', false); //disabled を無効にする＝ボタンが押せる
      $(".okawari .product-form__submit span").text('カートへ追加');
    }else{
      $(".okawari .product-form__submit").prop('disabled', true); //disabled を有効にする＝ボタンが押せない
      $(".okawari .product-form__submit span").text('15桁のIMEI番号を入力してください');
    }
  });

  
  
});


$(document).ready(function() {
  //===========================================================
  // カートページの購入ボタンを非活性（プライバシーポリシーのチェック時に購入ボタンの活性するため）
  //===========================================================
    $('#main-cart-footer .cart__checkout-button, #main-cart-footer .cart__footer .cart__dynamic-checkout-buttons').addClass('c_none');
    if($('body').hasClass('okawari')) {
      $('.product .okawari-form button').prop('disabled', true);
    }


  //===========================================================
  // レンタカー用　SNを入力せずに反映
  //===========================================================
  // URLを取得
  let url = new URL(window.location.href);
  // URLSearchParamsオブジェクトを取得
  let params = url.searchParams;
  // getメソッド
  const qrSn = params.get('sn');
  if(qrSn) {
    $("#engraveTxt2").val(qrSn).trigger('change');
  }


});

// JavaScriptでログイン状態を fetch 経由で判定する方法（2025年時点でも有効）
// async function isLoggedIn() {
//   const res = await fetch('/account', { credentials: 'include' });
//   const text = await res.text();
//   // ページ内に「ログイン」や「ログアウト」のワードで判定（日本語/英語対応）
//   return text.includes('/account/logout') || text.includes('ログアウト');
// }

// isLoggedIn().then(loggedIn => {
//   console.log('ログイン状態:', loggedIn);
//   if (loggedIn) {
//     // document.getElementById('registerButton').onclick = () => {
//     //   window.location.href = '/pages/device-register';
//     // };
//     console.log('ログイン済み');
//   } else {
//     // document.getElementById('registerButton').onclick = () => {
//     //   window.location.href = '/account/login';
//     // };
//     console.log('未ログイン');
//   }
// });


//画面スクロールでフレームインした時のエフェクトーーー
// 要素が画面内に入っているかをチェック
function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top < window.innerHeight &&
    rect.bottom > 0
  );
}

// スクロールや読み込み時にチェック
function checkInView() {
  $('[class*="in-screen"]').each(function () {
    const $el = $(this);
    
    // 対応する inview クラスを決定
    const classes = $el.attr('class').split(/\s+/);
    classes.forEach(cls => {
      if (cls.indexOf('in-screen') === 0) {
        const viewClass = cls.replace('in-screen', 'inview');
        if (!$el.hasClass(viewClass) && isInViewport(this)) {
          $el.addClass(viewClass);
        }
      }
    });
  });
}

// 初回とスクロール・リサイズ時に実行
$(document).ready(function () {
  checkInView();
  $(window).on('scroll resize', function () {
    checkInView();
  });
});
//画面スクロールでフレームインした時のエフェクトここまでーーー
//pd2025の情報ーーー
$(function () {
    const $fv = $('.pd2025 .fv');
    const $bgImg = $('.pd2025 .bg');

    if ($bgImg.length) {
      // imgが読み込まれたら active を追加
      $bgImg.on('load', function () {
        setTimeout(function () { //遅らせる
            $('.fv .text').addClass('show1');
          }, 200);
        setTimeout(function () { //遅らせる
            $('.fv .left').addClass('show2');
          }, 500);  
           setTimeout(function () { //遅らせる
            $('.fv .right').addClass('show2');
          }, 1000);
      }).each(function () {
        // キャッシュから読み込まれてる場合にも対応
        if (this.complete) $(this).trigger('load');
      });
    } else {
      // 背景がCSSのbackground-imageの場合は IntersectionObserver 推奨
      // 保険で即時追加（表示直後でもOKなら）
      $('.fv .text').addClass('show1');
      $('.fv .left').addClass('show2');
      $('.fv .right').addClass('show2');
    }

   $('.coupon').on('click', function () {
      const textToCopy = $(this).data('copy');

      // コピー処理
      const tempInput = $('<input>');
      $('body').append(tempInput);
      tempInput.val(textToCopy).select();
      document.execCommand('copy');
      tempInput.remove();

      // メッセージ表示
      const $msg = $('#copy-message');
      $msg.stop(true, true).addClass('show');

      // 3秒後にフェードアウト
      setTimeout(function () {
        $msg.removeClass('show');
      }, 3000);
    });
  $('.item-info-btn').on('click',function(){
     $('.item-info-table').stop().slideToggle(300,'swing');
    });

//フィックスボタンの開閉
  if ($('.pd2025').length) {
    $(window).on('scroll', function() {
      var triggerPoint = $('.fix-btn-end').offset().top;
      var scrollTop = $(window).scrollTop();
      var windowHeight = $(window).height();

      if (scrollTop + windowHeight >= triggerPoint) {
        $('.fix-btn').stop().addClass('show-fix');
      } else {
        $('.fix-btn').stop().removeClass('show-fix');
      }
    });
  }

  
  
  });
//pd2025の情報ここまでーーー